import * as React from "react"
import { cn } from "../lib/utils"

const badgeVariants = {
  default: "bg-primary text-primary-foreground",
  secondary: "bg-secondary text-secondary-foreground",
  success: "bg-success text-success-foreground",
  error: "bg-error text-error-foreground",
  warning: "bg-warning text-warning-foreground",
  info: "bg-info text-info-foreground",
  outline: "border border-border text-foreground",
}

function Badge({ className, color = "default", circular = false, children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-xs font-medium",
        circular ? "rounded-full" : "rounded",
        badgeVariants[color] ?? badgeVariants.default,
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}

export { Badge }
